import { useState, Suspense, useEffect } from 'react'
import './App.css'
import './assets/fonts/fonts.css'
import '/node_modules/bootstrap/dist/js/bootstrap.js'
import '/node_modules/bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.css'
import './assets/styles/assets/assets.css'
import './assets/styles/assets/dashboard.css'
import './assets/styles/sidebar/sidebar.css'
import './assets/styles/header/header.css'
import './assets/styles/user_login/userLogin.css'
import './assets/styles/master/main.css'
import './assets/styles/student/student.css'
import './assets/styles/student/studentLogin.css'
import './assets/styles/student/studentQuiz.css'
import './assets/styles/student/studentRegistration.css'
import "../src/i18n/i18n"
import { useRoutes } from 'react-router-dom'
import Routes from './routes/Route'
import FallbackPage from './routes/auth/FallbackPage'
import { ToastContainer } from 'react-toastify'
import DisableDevtool from 'disable-devtool';

function App() {

  const [collapsed, setCollapsed] = useState(false)

  function RouteLayout({ path }) {
    const element = useRoutes(path);
    return element;
  }

  useEffect(() => {
    DisableDevtool()
  }, [])

  return (
    <div className="App">

      <Suspense fallback={<FallbackPage />}>
        <RouteLayout path={Routes()} />
      </Suspense>

      <ToastContainer />

    </div>
  );
}

export default App;